<template>
    <v-card>
        <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="Search"
                single-line
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :footer-props="footerProps"
            :headers="headers"
            :items="usersList"
            :items-per-page="20"
            :loading="loading"
            :options.sync="options"
            :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
            :search="search"
            :server-items-length="usersCount"
            class="elevation-1"
            loading-text="Loading users"
        >

            <template v-slot:item.edit="{ item }">
                <v-btn
                    :to="{name: 'user-view', params: {id: item.id}}"
                    color="primary"
                    icon
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import debounce from "debounce";

export default {
    name: "UserListTable",
    data() {
        return {
            search: '',
            options: this.tableOptions,
            footerProps: {"items-per-page-options": [20, 50, 100, 500]},
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Email',
                    align: 'center',
                    sortable: false,
                    value: 'email',
                },
                {
                    text: 'Role',
                    align: 'center',
                    sortable: false,
                    value: 'role',
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'edit',
                },
            ],
        }
    },
    computed: {
        ...mapState('user', ['usersList', 'loading', 'usersCount', 'tableOptions'])
    },
    watch: {
        async search() {
            this.cancelPendingRequests('user')
            await this.setSearchString(this.search);
            this.debouncedSearch(this.search);
        },
        options(val) {
            this.setTableOptions(val);
        },
    },
    created() {
        this.debouncedSearch = debounce(() => {
            this.setTableOptions({...this.tableOptions, page: 1});
        }, 300)
    },
    methods: {
        ...mapActions('user', ['fetchUserList']),
        ...mapActions('app', ['cancelPendingRequests']),
        ...mapMutations('user', ['setTableOptions', 'setSearchString']),
    }
}
</script>

<style scoped>

</style>